import { Component } from '@angular/core';
import { BaseComponent } from 'src/app/shared/components/base.component';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { MessageService } from 'primeng/api';
import { WebStorageService } from '../../../shared/services/web-storage.service';
import { finalize } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { OnboardService } from 'src/app/services/onboard.service';
import { Onboard } from 'src/app/interfaces/onboard';

@Component({
  selector: 'app-on-boarding',
  templateUrl: './on-boarding.component.html',
  styleUrls: ['./on-boarding.component.sass'],
  standalone: false
})
export class OnBoardingComponent extends BaseComponent {
  selectedFile: File = null;
  items: Onboard[];

  constructor(private service: OnboardService, private http: HttpClient, private webStorageService: WebStorageService, messageService: MessageService) {
    super(messageService);
    this.loadData();
  }

  loadData() {
    this.service.getAll().subscribe((result) => {
      if (result) {
        this.items = result.responseModel;
      }
    });
  }

  downloadTemplate() {
    this.service.getTemplate().subscribe((result: Blob) => {
      this.storeFileLocally(result, 'appointments.xlsx');
    });
  }

  selectFile(files: any[]) {
    if (files.length === 0) {
      return;
    }

    let fileExtension = files[0].name.split('.').pop();
    if (fileExtension !== 'xlsx') {
      this.showErrorMessage('Please upload EXCEL file.');
      return;
    }

    this.selectedFile = files[0];
  }

  verifyFile() {
    const loggedInUserId = this.webStorageService.getCurrentUserToken().userId;

    const formData = new FormData();
    formData.append('file', this.selectedFile, this.selectedFile.name);
    formData.append('userId', loggedInUserId.toString());

    this.loading = true;
    this.http
      .post(environment.apiBaseUrl + 'onboard', formData)
      .pipe(finalize(() => (this.loading = false)))
      .subscribe((result: any) => {
        if (result) {
          const badRecords = result.responseModel.badDataCount;

          if (badRecords > 0) {
            this.showErrorMessage(`Appointment verification error: There are ${badRecords} bad records`);
          } else {
            this.showSuccessMessage('All the appointments processed and imported successfully.');
          }
          this.loadData();
        }
      });
  }

  downloadFile(onboardId: number, fileName: string) {
    this.loading = true;
    this.service
      .getFile(onboardId)
      .pipe(finalize(() => (this.loading = false)))
      .subscribe((result: Blob) => {
        this.storeFileLocally(result, fileName);
      });
  }

  storeFileLocally(file: Blob, fileName: string) {
    const downloadedFile = new Blob([file], { type: file.type });
    const a = document.createElement('a');
    a.setAttribute('style', 'display:none;');
    a.download = fileName;
    document.body.appendChild(a);
    a.target = '_blank';
    a.href = URL.createObjectURL(downloadedFile);
    document.body.removeChild(a);
    a.click();
  }
}
